import React, { FC, useEffect } from 'react';
// import { useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';

import { useFormik } from 'formik';

import FormFooter from '../../../containers/form-footer';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import ModuleTitleText from '../../../modules/module-title-text/module-title-text';
import Step from '../../../modules/step';
import UiInput from '../../../modules/ui/ui-input/ui-input';
import { useAppDispatch } from '../../../store';
import { initPurchase } from '../../../store/actions/operations-sign';
// import { RootState } from "../../../types";
import currencyFormat from '../../../utils/currencyFormat';
import BuyIcon from '../cfa-release-form/icons/buy-icon.svg';

import './index.scss';

type FormStateType = {
  claim?: string;
};

const initialFormState: FormStateType = {};

const MIN = 50000;
const MAX = 150000000;

const AssetsBuyingForm: FC<{ value?: number }> = ({ value }) => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  // const balance = useSelector(
  //   (state: RootState) => state.balance.data.info?.holdTokenValue
  // );

  const formState = useFormik({
    initialValues: initialFormState,
    onSubmit: (values) => {
      if (values.claim) {
        dispatch(
          initPurchase({
            info: {
              amount: Number(values.claim.replace(/\s/g, '')),
            },
          })
        ).then((action) => {
          if (action.meta.requestStatus === 'fulfilled') {
            history.push('/assets/signing');
          }
        });
      }
    },
    validate: (values) => {
      const errors: Record<string, string> = {};

      // if (
      //   values &&
      //   values.claim &&
      //   balance &&
      //   Number(values.claim.replace(/\s/g, "")) > balance
      // ) {
      //   errors.claim = "Превышен доступный лимит";
      // }
      if (
        values &&
        values.claim &&
        Number(values.claim.replace(/\s/g, '')) > MAX
      ) {
        errors.claim = `Максимальная сумма: ${MAX.toLocaleString('ru')}₽`;
      }
      if (
        values &&
        values.claim &&
        Number(values.claim.replace(/\s/g, '')) < MIN
      ) {
        errors.claim = `Минимальная сумма: ${MIN.toLocaleString('ru')}₽`;
      }
      return errors;
    },
  });

  const getFieldError = (field: keyof FormStateType) =>
    formState.errors[field] ? (
      <div className="form-item__footer">
        <span className="red">{formState.errors[field]}</span>
      </div>
    ) : null;

  useEffect(() => {
    if (value) {
      formState.setFieldValue('claim', String(value));

      if (formState.isValid) formState.handleSubmit();
    }
  }, [value]);

  return (
    <form className="form-assets">
      <Step
        steps={[
          { title: 'Выбор суммы', active: true },
          { title: 'Заявка' },
          { title: 'Статус заявки' },
        ]}
      />
      <div className="form-assets__item form-assets__item__sum">
        <p className="form-title">Введите сумму, которую хотите купить:</p>
        <div className="form-item">
          <UiInput
            name="claim"
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
              !Number.isNaN(Number(e.currentTarget.value.replace(/\s/g, ''))) &&
                formState.setFieldValue('claim', e.currentTarget.value);
            }}
            value={
              formState.values?.claim
                ? Number(
                    formState.values.claim.replace(/\s/g, '')
                  ).toLocaleString('ru')
                : undefined
            }
            error={formState.errors.claim}
            lg
            label="Сумма:"
            rightTextClassName="input-credit__rub-icon"
            rightText="₽"
          />
          {getFieldError('claim')}
        </div>
      </div>
      <FormFooter>
        <div className="flex justify-end">
          {formState.values?.claim && (
            <div className="form-assets__flex">
              <div className="form-assets__item form-assets__item--sm">
                <ModuleTitleText
                  top="Вы покупаете цифровые финансовые активы на сумму:"
                  bottom={
                    formState.values &&
                    formState.values.claim &&
                    currencyFormat(
                      Number(formState.values.claim.replace(/\s/g, ''))
                    )
                  }
                />
              </div>
            </div>
          )}
          <IconBtn
            disabled={!formState.isValid || !formState.values.claim}
            onClick={() => formState.handleSubmit()}
            icon={BuyIcon}
            title="Купить ЦФА"
          />
        </div>
      </FormFooter>
    </form>
  );
};

export default AssetsBuyingForm;
